export default "/images/image_2.jpg?402d1a25b6880de01afb01754532264e";